import { lazy } from "react";

export const PageAdminAbout = lazy(() => import("./About"));
export const PageAdminMissionVision = lazy(() => import("./MissionVision"));